type UserGroup = {
  ADMIN: string;
  PUBLISHER: string;
}

export const userGroup: UserGroup = {
  ADMIN: "896723",
  PUBLISHER: "567523",
};
